module.exports = __webpack_public_path__ + "img/VOLAIL.35a35c71.png";